<template>
  <div v-if="cert_data != null">
    <center>
      <v-btn class="button no-display" @click="print"> Print </v-btn>
      <v-btn class="button no-display" rounded @click="close()"> Close </v-btn>
    </center>
    <div id="document1">
      <div class="main" >
        <div style="background-color: white; border: 2px solid black; padding: 10px;">
          <v-row>
            <v-col cols="12" sm="2" md="2" class="text-center">
              <img class="logo" v-if="org_basic_data.school_logo" :src="org_basic_data.school_logo" width="120"
                height="120" alt="logo" />
            </v-col>
            <v-col cols="12" sm="8" md="8" class="text-center print-align" style="font-weight: bold;">
              <span class="pb-0" v-if="org_basic_data.trust_name">{{ org_basic_data.trust_name }}</span>
              <h2 v-if="cert_data.section_name == 'Primary'">Vishwakarma Vidyalaya English Primary</h2>
              <div style="font-size: 25px;" v-else-if="cert_data.section_name == 'Secondary'">Vishwakarma Vidyalaya
                English Secondary</div>
              <div style="font-size: 25px;" v-else-if="cert_data.section_name == 'Pre-Primary'">Vishwakarma Vidyalaya
                English Pre-Primary</div>
              <div style="font-size: 25px;" v-else-if="cert_data.section_name == 'Higher Secondary'">Vishwakarma
                Vidyalaya English Higher Secondary</div>
              <div style="font-size: 25px;" v-else>{{ org_basic_data.school_name }}</div>
              <h2 style="text-decoration: underline;">Bonafide Certificate</h2>
              <h3>To whom so ever it may concern</h3>
            </v-col>
          </v-row>
          <hr style="border: 1px solid black">
          <br>
          <div class="row px-6">
            <div class="middle col-8 py-0">
              <p>Bonafide No. <b>{{ cert_data.cert_no }}</b></p>
              <p>This is to certify that :-</p>
              <p>Miss / Master : <b>{{ cert_data.stud_name }}</b></p>
              <p>Is/was studying in our school in std. <b>{{ cert_data.std }}</b> Since June - <b>{{ cert_data.ay }}</b>
              </p>

              <p>As per our General Register No: <b>{{ cert_data.gr_no }}</b> his/her details are as follows</p>
              <p>Mother's Name : <b>{{ cert_data.mother_name }}</b></p>
              <p>Nationality : <b>{{ cert_data.nationality }}</b></p>
              <p>Religion and Caste : <b>{{ cert_data.religion }} {{ cert_data.caste }}</b></p>
              <p>Place of Birth : <b>{{ cert_data.place_of_birth }}</b></p>
              <p>Date of Birth : <b>{{ cert_data.dob }}</b></p>
            </div>
            <div class="col-3">
              <div v-if="cert_data.photo">
                <img class="profile-photo" :src="awspath + cert_data.photo" width="180" height="180"
                  style="border: 1px solid black;" />
              </div>
            </div>
          </div>
          <v-row class="px-6 py-0 line-height">
            <v-col cols="12" sm="12" md="12">
              <p class="mb-0">
                Reason : <b>{{ cert_data.reason }}</b>
              </p>
            </v-col>
          </v-row>
          <br>
          <div class="bottom pa-6">
            Date : <b>{{ cert_data.cert_date }}</b>
            <br><br>
            <v-row>
              <v-col cols="12" sm="6" md="6">Place :<b> Pune </b></v-col>
              <v-col cols="12" sm="6" md="6" align="center"><b>Stamp and Signature</b></v-col>
            </v-row>
          </div>
          <br>
        </div>
      </div>
    </div>
    <br><br><br>
    <v-card class="box">
      <div class="no-display">
        <center><span>------- Modify -------</span></center>
        <v-row>
          <v-col cols="12" sm="4" md="4">
            <v-text-field style="margin-left: 77px;" label="Student Reason"
              v-model.trim="cert_data.reason"></v-text-field>
          </v-col>
        </v-row>
      </div>
    </v-card>

  </div>
</template>

<script>
import axios from "axios";
import VueHtml2pdf from "vue-html2pdf";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
export default {
  data() {
    return {
      snackbar: false,
      awspath: "",
      snackbar_msg: "",
      color: "",
      cert_data: null,
      org_basic_data: [],
      progress: 0,
    };
  },
  watch: {
    progress(val) {
      this.$emit("progress", val);
    },
  },
  components: {
    VueHtml2pdf,
  },
  methods: {
    print() {
      var content = document.getElementById("document1").innerHTML;
      var mywindow = document.body.innerHTML;
      document.body.innerHTML = content;
      window.print();
      document.body.innerHTML = mywindow;
      location.reload();
      return true;
    },
    // print() {
    //   this.$store.state.drawer = false;
    //   let that = this;
    //   window.onafterprint = function () {
    //     that.$store.state.drawer = true;
    //   };
    //   setTimeout(function () {
    //     window.print();
    //   }, 100);
    // },
    close() {
      this.$router.push({ name: "certificate-bonafied", target: "blank" });
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
    onload() {
      this.cert_data = JSON.parse(this.$route.query.cert_data || '{}');
      this.org_basic_data = JSON.parse(this.$route.query.org_basic_data || '{}');
    },
  },
  mounted() {
    this.awspath = localStorage.getItem("awspath");
    this.onload();
  },
};
</script>
<style scoped>
.main {
  margin-left: 15%;
  margin-right: 15%;
}

@media print {
  .logo {
    height: 280px !important;
    width: 280px !important;
  }

  .profile-photo {
    height: 380px !important;
    width: 380px !important;
  }

  .line-height {
    line-height: 100%;
  }

  .padding {
    padding: 20px;
  }

  header,
  footer,
  nav,
  date {
    display: none !important;
  }

  .no-display,
  .v-input__control,
  input[type="button"],
  input[type="submit"],
  input[type="reset"],
  #v-card,
  .box {
    display: none !important;
  }

  .main {
    width: 100% !important; 
    font-size: 30px; 
    padding: 0 !important;
    margin: 0 !important;
  }

  .print-align {
    text-align: center;
    line-height: 200%;
  }

  @page {
    size: 13.5in 16.5in !important;
  }

  .middle {
    line-height: 250% !important;
  }
}
</style>